export var isEmptyString = function isEmptyString(value) {
  return value === '';
};